export enum TechCardStatuses {
	released = 'released',
	accepted_at_sgd = 'accepted_at_sgd',
	progress = 'progress',
	canceled = 'canceled',
	partially_issued = 'partially_issued',
	completed = 'completed',
	accepted_at_storage = 'accepted_at_storage',
	wasted = 'wasted',
}
export enum UserRoles {
	user = 'user',
	operator = 'operator',
	admin = 'admin',
	senior_operator = 'senior_operator',
	storekeeper = 'storekeeper',
}

export type StandardConsumptionTypeEnum = 'meters' | 'square_meters' | 'grams' | 'kg' | 'old';

export type TechCardStatus = `${TechCardStatuses}`;

export type UserRole = `${UserRoles}`;
